import React, { useState } from "react";
import {
    Button,
    Col,
    Row,
    Spin,
    Card,
    Form,
    Input,
    message
} from "antd";
import "./GeneralLedger.css";
import { exportBookEntryDetails } from "../../Utils/GeneralLedger/ExportBookEntryDetails";
import { monitorBookEntry } from "./GeneralLedgerService";

const BookEntryDetails = ({loginPlaceId}) => {
    const [formState, setFormState] = useState({
        transactionNumber: ""
    });

    const [loading, setLoading] = useState(false);

    const isGenerateDisabled = !formState.transactionNumber.trim();

    const handleChange = (e) => {
        setFormState({
            ...formState,
            transactionNumber: e.target.value
        });
    };

    // ✅ API Call
    const handleBookEntryListApi = async () => {
        try {
            setLoading(true);

            const payload = formState.transactionNumber.trim();

            const response = await monitorBookEntry(payload);


            if (response?.data) {
                // ✅ Export to Excel
                exportBookEntryDetails(response,loginPlaceId);
                // message.success("Report generated successfully");
            } else {
                message.warning("No data found");
            }

        } catch (error) {
            console.error(error);
            message.error("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="panel-container">
            <Card hoverable className="inner-card">
                <Form layout="vertical">
                    <Row gutter={[16, 16]} justify="space-around">

                        <Col span={24}>
                            <Form.Item label="Transaction/Book Entry Number">
                                <Input
                                    placeholder="Transaction Number Or Book Entry Number"
                                    value={formState.transactionNumber}
                                    onChange={handleChange}
                                />
                            </Form.Item>
                        </Col>

                        {/* Generate Button */}
                        <Col span={24} style={{ textAlign: "right" }}>
                            <Form.Item>
                                <Button
                                    onClick={handleBookEntryListApi}
                                    disabled={loading || isGenerateDisabled}
                                    className="generate-btn"
                                    type="primary"
                                >
                                    {loading ? <Spin size="small" /> : "Generate Report"}
                                </Button>
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
            </Card>
        </div>
    );
};

export default BookEntryDetails;